module.exports = __webpack_public_path__ + "static/landing1-hero-phone-5a912f417ea5fd3d9b5e4fdeda84c9ea.png";